export const menuItems = [
  {
    title: 'Lifetime Mortgages',
    submenu: [
      {
        icon: <img src="/img/icons/home-smile.svg" alt="Home Smile"/>,
        title: 'Our Lifetime Mortgages',
        description: 'Find the right lifetime mortgage for your customers\' financial needs.',
        href: '/professionals/lifetime-mortgages',
      },
      {
        icon: <img src="/img/icons/file-search-02.svg" alt="File Search"/>,
        title: 'Lending Criteria',
        description: 'Save time and effortlessly browse our lending criteria.',
        href: '/professionals/lifetime-mortgages/lending-criteria',
      },
      {
        icon: <img src="/img/icons/file-plus-02.svg" alt="File Plus"/>,
        title: 'Create KFI',
        description: 'Start a customer\'s journey with our KFI application process.',
        href: 'https://adviserportal.pureretirement.co.uk/my/create-kfi/',
      },
      {
        icon: <img src="/img/icons/file-heart-02.svg" alt="File Heart"/>,
        title: 'Servicing Solutions',
        description: 'Later life finance partner opportunities with Pure.',
        href: '/professionals/lifetime-mortgages/servicing-solutions',
      },
      {
        icon: <img src="/img/icons/user-square.svg" alt="User Square"/>,
        title: 'Find my BDM',
        description: 'Easily find your local sales contact with our convenient postcode finder.',
        href: '/professionals/lifetime-mortgages/find-my-bdm',
      },
      {
        icon: <img src="/img/icons/percent-03.svg" alt="Percent 03"/>,
        title: 'Interest Servicing ',
        description: 'Empower borrowing with discounted interest rates. ',
        href: '/professionals/lifetime-mortgages/interest-servicing',
      },
    ],
  },
  {
    title: 'Resources',
    submenu: [
      {
        icon: <img src="/img/icons/grid-01.svg" alt="Grid 01"/>,
        title: 'Resources',
        description: 'Gain an understanding of the market and learn how to succeed within it.',
        href: '/professionals/resources',
      },
      {
        icon: <img src="/img/icons/colors.svg" alt="Colors"/>,
        title: 'Marketing Toolkit',
        description: 'Grow your reputation in later life finance with customisable templates.',
        href: '/professionals/resources/marketing-toolkit',
      },
      {
        icon: <img src="/img/icons/graduation-hat-01.svg" alt="Graduation Hat 01"/>,
        title: 'Academy',
        description: 'Get market insight with our research and learn about customer habits.',
        href: '/professionals/resources/academy',
      },
      {
        icon: <img src="/img/icons/help-hexagon.svg" alt="Help Hexagon"/>,
        title: 'Adviser Support Tools',
        description: 'Find solutions with our case studies, and FAQs.',
        href: '/professionals/resources/adviser-support-tools',
      },
      {
        icon: <img src="/img/icons/check-heart.svg" alt="Check Heart"/>,
        title: 'Customer Support Tools',
        description: 'Resources including Consumer Duty to help your customers\' journey.',
        href: '/professionals/resources/customer-support-tools',
      },
      {
        icon: <img src="/img/icons/calculator.svg" alt="Calculator"/>,
        title: 'Calculators',
        description: 'Use our lifetime mortgage calculators to illustrate later life lending options.',
        href: '/professionals/resources/lifetime-mortgage-calculators',
      },
    ],
  },
  {
    title: 'About us',
    submenu: [
      {
        icon: <img src="/img/icons/info-circle.svg" alt="Info Circle"/>,
        title: 'About Pure Retirement',
        description: 'Find out why we\'re known as lifetime mortgage specialists.',
        href: '/professionals/about-us',
      },
      {
        icon: <img src="/img/icons/rocket-01.svg" alt="Rocket 01"/>,
        title: 'Our Responsible Lending Mission',
        description: 'Responsible lending is at the heart of our business.',
        href: '/professionals/about-us/our-responsible-lending',
      },
      {
        icon: <img src="/img/icons/users-01.svg" alt="Users 01"/>,
        title: 'Our Later Life Finance Partners',
        description: 'Get to know the partners helping us deliver best-in-class results.',
        href: '/professionals/about-us/our-later-life-finance-partners',
      },
      {
        icon: <img src="/img/icons/globe-04.svg" alt="Globe 04"/>,
        title: 'Our Corporate Social Responsibility',
        description: 'Learn how we put our ESG principles and UN goals into practice.',
        href: '/professionals/about-us/our-corporate-social-responsibility',
      },
    ],
  },
  {
    title: 'News',
    submenu: [
      {
        icon: <img src="/img/icons/trend-up-01.svg" alt="Trend Up 01"/>,
        title: 'Market Trends',
        description: 'Our quarterly reports cover customer demographics, habits, and market trends.',
        href: '/professionals/news/equity-release-market-trends',
      },
      {
        icon: <img src="/img/icons/monitor-03.svg" alt="Monitor 03"/>,
        title: 'Insight Blogs',
        description: 'Stay on top of the latest updates and later life lending news.',
        href: '/professionals/news/insight-blog',
      },
      {
        icon: <img src="/img/icons/book-open-01.svg" alt="Book Open 01"/>,
        title: 'Press Releases',
        description: 'Never miss an update. Follow our latest news and product features.',
        href: '/professionals/news/press-releases',
      },
    ],
    isFeaturedContent: true,
    isOnly3Items: true,
  },
  {
    title: 'Events',
    submenu: [
      {
        icon: <img src="/img/icons/presentation-chart-01.svg" alt="Presentation Chart 01"/>,
        title: 'Events Hub',
        description: 'Browse our CPD events from online webinars to in-person conferences.',
        href: '/professionals/events',
      },
      {
        icon: <img src="/img/icons/certificate-01.svg" alt="Certificate 01"/>,
        title: 'CPD Certificate',
        description: 'Attended one of our events? Download your CPD certificate today.',
        href: '#',
      },
    ],
  },
];

export const menuItemsMobile = [
  {
    title: 'Lifetime Mortgages',
    href: '/professionals/lifetime-mortgages',
    submenu: [
      { title: 'Our Lifetime Mortgages', href: '/professionals/lifetime-mortgages' },
      { title: 'Lending Criteria', href: '/professionals/lifetime-mortgages/lending-criteria' },
      { title: 'Create KFI', href: 'https://adviserportal.pureretirement.co.uk/my/create-kfi/' },
      { title: 'Servicing Solutions', href: '/professionals/lifetime-mortgages/servicing-solutions' },
      { title: 'Find my BDM', href: '/professionals/lifetime-mortgages/find-my-bdm' },
      { title: 'Interest Servicing', href: '/professionals/lifetime-mortgages/interest-servicing' },
    ],
  },
  {
    title: 'Resources',
    href: '/professionals/resources',
    submenu: [
      { title: 'Resources', href: '/professionals/resources' },
      { title: 'Marketing Toolkit', href: '/professionals/resources/marketing-toolkit' },
      { title: 'Academy', href: '/professionals/resources/academy' },
      { title: 'Adviser Support Tools', href: '/professionals/resources/adviser-support-tools' },
      { title: 'Customer Support Tools', href: '/professionals/resources/customer-support-tools' },
      { title: 'Calculators', href: '/professionals/resources/lifetime-mortgage-calculators' },
    ],
  },
  {
    title: 'About us',
    href: '/professionals/about-us',
    submenu: [
      { title: 'About Pure Retirement', href: '/professionals/about-us' },
      { title: 'Our Responsible Lending', href: '/professionals/about-us/our-responsible-lending' },
      { title: 'Our Later Life Finance Partners', href: '/professionals/about-us/our-later-life-finance-partners' },
      { title: 'Our Corporate Social Responsibility', href: '/professionals/about-us/our-corporate-social-responsibility' },
    ],
  },
  {
    title: 'News',
    href: '#',
    submenu: [
      { title: 'Market Trends', href: '/professionals/news/equity-release-market-trends' },
      { title: 'Insight Blogs', href: '/professionals/news/insight-blog' },
      { title: 'Press Releases', href: '/professionals/news/press-releases' },
    ],
  },
  {
    title: 'Events',
    href: '/professionals/events',
    submenu: [
      { title: 'Events Hub', href: '/professionals/events' },
      { title: 'CPD Certificate', href: '#' },
    ],
  },
];

export const customerMenuItems = [
  {
    title: 'Equity Release',
    submenu: [
      {
        icon: <img src="/img/icons/home-04-alt.svg" alt="home-04"/>,
        title: 'Equity Release',
        description: 'Discover what lifetime mortgages are and how they support later life borrowing goals.',
        href: '/equity-release',
      },
      {
        icon: <img src="/img/icons/file-question-03.svg" alt="file-question"/>,
        title: 'What Is Equity Release?',
        description: 'Learn if you are eligible and what equity release is used for.',
        href: '/equity-release/what-is-equity-release',
      },
      {
        icon: <img src="/img/icons/book-open-01-alt.svg" alt="book-open"/>,
        title: 'How Does Equity Release Work?',
        description: 'Explore how equity release works and what to consider.',
        href: '/equity-release/how-does-equity-release-work',
      },
      {
        icon: <img src="/img/icons/file-search-02-alt.svg" alt="file-search"/>,
        title: 'Definitive Equity Release Glossary',
        description: 'Navigate your way through later life finance terminology with our handy glossary.',
        href: '/equity-release/definitive-equity-release-glossary',
      },
    ],
  },

  {
    title: 'Knowledge Corner',
    submenu: [
      {
        icon: <img src="/img/icons/lightbulb-04-alt.svg" alt="light-bulb"/>,
        title: 'Knowledge Corner',
        description: 'Explore questions and articles on later life finance and retirement planning.',
        href: '/knowledge-corner',
      },
      {
        icon: <img src="/img/icons/messsage-check-square-alt.svg" alt="message-check"/>,
        title: 'Your FAQs Answered',
        description: 'Find answers for your equity release and later life borrowing questions.',
        href: '/knowledge-corner/equity-release-faqs',
      },
      {
        icon: <img src="/img/icons/clock-fast-forward.svg" alt="clock-fast"/>,
        title: 'Later Life Borrowing And You',
        description: 'Coming soon.',
        href: '#',
      },
    ],
  },

  {
    title: 'Existing Customers',
    submenu: [
      {
        icon: <img src="/img/icons/users-01-alt.svg" alt="users-01"/>,
        title: 'Existing Customers',
        description: 'Are you an existing customer? Find helpful resources here.',
        href: '/existing-customers',
      },
      {
        icon: <img src="/img/icons/annotation-question.svg" alt="annotation-question"/>,
        title: 'Existing Customers FAQs',
        description: 'Learn more about your existing plan and how to access support.',
        href: '/existing-customers/existing-customers-faqs',
      },
    ],
  },

  {
    title: 'About Us',
    submenu: [
      {
        icon: <img src="/img/icons/info-circle-alt.svg" alt="info-circle"/>,
        title: 'About Us',
        description: 'Get to know us and how we became lifetime mortgage specialists.',
        href: '/about-us',
      },
      {
        icon: <img src="/img/icons/briefcase-02.svg" alt="briefcase-02"/>,
        title: 'Careers',
        description: 'Find our latest vacancies listed here.',
        href: '/careers',
      },
      {
        icon: <img src="/img/icons/globe-04-alt.svg" alt="globe-04"/>,
        title: 'Responsible Business',
        description: 'Explore how we work and how we do business sustainably.',
        href: '/about-us/responsible-business',
      },
    ],
  },

  {
    title: 'MyPure',
    submenu: [
      {
        icon: <img src="/img/icons/user-square-alt.svg" alt="user-square"/>,
        title: 'MyPure',
        description: 'Learn more about self-managing your lifetime mortgage online.',
        href: '/my-pure',
      },
      {
        icon: <img src="/img/icons/arrow-circle-broken-right.svg" alt="briefcase-02"/>,
        title: 'MyPure Login',
        description: 'Log into your MyPure online account here.',
        href: 'https://customer.pureretirement.co.uk',
      },
      {
        icon: <img src="/img/icons/file-check-02-alt.svg" alt="file-check"/>,
        title: 'MyPure Register',
        description: 'Start self-managing your lifetime mortgage via our online platform.',
        href: 'https://identity.purewebservices.co.uk/Register/Index?returnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3DPure%2520Customer%2520Web%26scope%3Dopenid%2520profile%2520offline_access%2520CustomerPortal_API%2520Gateway%2520Gateway_Proxy%26response_type%3Dcode%26redirect_uri%3Dhttps%253A%252F%252Fcustomer.pureretirement.co.uk%252Foauth%252Fcallback%26response_mode%3Dquery%26nonce%3DVd69kBOc06yqwYgda48LWHfa4MHTVPAIuJhiuTPr540%26state%3DeyJyZXR1cm5UbyI6Ii9zaWduaW4ifQ%26code_challenge_method%3DS256%26code_challenge%3DMFYBp0gtD5iMNm9d-alEgO9GZQEVnA3v5IDI0PphBgw',
        customClass: 'col-start-2 col-end-3',
      },
    ],
  },
];

export const customerMenuItemsMobile = [
  {
    title: 'Equity Release',
    href: '/equity-release',
    submenu: [
      { title: 'Equity Release Page', href: '/equity-release' },
      { title: 'What Is Equity Release?', href: '/equity-release/what-is-equity-release' },
      { title: 'How Does Equity Release work?', href: '/equity-release/how-does-equity-release-work' },
      { title: 'Definitive Equity Release Glossary', href: '/equity-release/definitive-equity-release-glossary' },
    ],
  },
  {
    title: 'Knowledge Corner',
    href: '/knowledge-corner',
    submenu: [
      { title: 'Knowledge Corner Page', href: '/knowledge-corner' },
      { title: 'Your FAQs Answered', href: '/knowledge-corner/equity-release-faqs' },
      { title: 'Later Life Borrowing And You', href: '#' },
    ],
  },
  {
    title: 'Existing Customers',
    href: '/existing-customers',
    submenu: [
      { title: 'Existing Customers Page', href: '/existing-customers' },
      { title: 'Existing Customers FAQs', href: '/existing-customers/existing-customers-faqs' },
    ],
  },
  {
    title: 'About Us',
    href: '/about-us',
    submenu: [
      { title: 'About Us Page', href: '/about-us' },
      { title: 'Responsible Business', href: '/about-us/responsible-business' },
    ],
  },
  {
    title: 'MyPure',
    href: '/my-pure',
    submenu: [
      { title: 'MyPure Page', href: '/my-pure' },
      { title: 'MyPure Register', href: 'https://customer.pureretirement.co.uk' },
      { title: 'Contact Us', href: '/contact-us' },
    ],
  },
];

export const footerLinks = [
  {
    icon: <img src="/img/icons/linkedin-white.svg" alt="LinkedIn"/>,
    href: 'https://www.linkedin.com/company/pure-retirement-ltd',
    label: 'LinkedIn',
  },
  {
    icon: <img src="/img/icons/youtube-white.svg" alt="YouTube"/>,
    href: 'https://www.youtube.com/@pureretirementforourcustom6170/videos',
    label: 'YouTube',
  },
];

// Customer-specific page paths that should stay in customer tab
export const CUSTOMER_SPECIFIC_PATHS = [
  '/privacy-policy',
  '/cookie-policy',
  '/terms-and-conditions',
  '/complaints-procedure',
  '/gender-pay-report',
  '/anti-slavery-statement',
  '/equity-release',
  '/knowledge-corner',
  '/existing-customers',
  '/about-us',
  '/my-pure',
  '/contact-us',
  '/careers',
];
